module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAARlJREFUKBWdUS2ug0AQ/koQVBAMCRqFo4YbcBkuwClwcAIUgpPQYGpbQYtCICAYQiD0zb4MWWjNe1+yme9nZjcDp/UH+AfU40wURdB1/WhjGAaEYbj5H4OapiEIgq2BSZIkTEVVZFVVFWzblq2Nk0/5BtqRkabp2nUdy10ln3LG7sW+72EYxnapTMinnLHbsa5rXK9Xzj4q5YwTPc3idrthnmfkeQ7XdVGWJTzPg+M4okVVVVwul1/OQ1TZLIoCj8cD4ziK6vs+LMuSWwFeVq5xHK/LsgiLKukjdh+Hr1QUBXQIMudc+LL4C//64vl8FvvRRbQn6SN2v4PDpmmQZRlM00TbtiB9xNfB+/2OaZrwer1E//P5PM7hDatUwnoOuYt5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/lampara-mesa.png
// module id = 509
// module chunks = 0